import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import SaleDocs from "../saleDocs/SaleDocs";
import SaleDocForm from "../saleDocs/SaleDocForm";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import * as constants from "../assets/constants";

class FragmentSaleDocs extends BaseComponent {
    constructor(props) {
        super(props)
        const state = {
            saleDocsState: null,
            activePanelSaleDocs: "saledocs_panel",
            current_doc: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    receiveMessage = (event) => {

    }

    selectCurrentDoc = (item, is_club = false, is_monitoring = false) => {
        this.setState({current_doc: item})
        if (constants.AdaptivityContext.isMobile && !is_monitoring) {

            this.setState({activePanelSaleDocs: "saledoc_form_panel"})
        }
    }


    hideDoc = (is_club = false) => {

        this.setState({activePanelSaleDocs: "saledocs_panel"})

    }

    render() {
        return <View activePanel={this.state.activePanelSaleDocs}>

            <Panel id="saledocs_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' :this.MainMenu()}
                    <SplitCol>
                        <SaleDocs father={this} base_url={this.state.base_url}
                                  select_doc={this.selectCurrentDoc}
                                  current_user={this.props.current_user}
                                  openFromUrl={true}
                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile &&
                        <SplitCol className="sale-docs-form-scroll" style={{
                            position: "sticky",
                            top: "0px",
                            height: "100vh",
                            overflowY: "auto",
                            overscrollBehavior: "contain"
                        }}>
                            <SaleDocForm
                                base_url={this.state.base_url}
                                current_doc={this.state.current_doc}
                                select_doc={this.selectCurrentDoc}
                                current_user={this.props.current_user}
                            />
                        </SplitCol>}
                </SplitLayout>
            </Panel>
            <Panel id="saledoc_form_panel">
                <SaleDocForm
                    base_url={this.state.base_url}
                    current_doc={this.state.current_doc}
                    current_user={this.props.current_user}
                    show_back={true}
                    hideDoc={this.hideDoc}
                    select_doc={this.selectCurrentDoc}
                />
            </Panel>
        </View>
    }
}

export default FragmentSaleDocs